module.exports = __webpack_public_path__ + "img/tool_1.3f8e14bf.png";